import { DataTableAssign } from "@/components/custom/data-table/data-table-assign";

export function BulkServiceVersionSelectionTable({
  context,
}: {
  context: any;
}) {
  return (
    <DataTableAssign
      context={context}
      pageOptions={[10]}
      ShowPaginationOptions={{ showPerPage: false, showRefresh: false }}
      scroll={{
        className: "flex-1 min-h-[200px]",
      }}
    />
  );
}
